export enum ApplicationStatus {
    UNDEFINED = 0,
    IN_REVIEW = 1,
    APPROVED = 2,
    DECLINED = 3,
}
